import { useQuery } from '@tanstack/react-query';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { getCurrentAdmin } from './lib/api';
import { Loading } from './components/ui';
import { DashboardPage } from './pages/Dashboard';
import { UsersPage } from './pages/Users';
import { UserDetailPage } from './pages/UserDetail';
import { PricingPage } from './pages/Pricing';
import { AntiAbusePage } from './pages/AntiAbuse';
import { ReportsPage } from './pages/Reports';
import { AuditLogPage } from './pages/AuditLog';
import { LoginPage } from './pages/Login';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/anti-abuse" element={<AntiAbusePage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/audit-log" element={<AuditLogPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}

function RequireAuth(): JSX.Element {
  const location = useLocation();
  const meQ = useQuery({ queryKey: ['me'], queryFn: getCurrentAdmin, retry: false });

  if (meQ.isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Loading />
      </div>
    );
  }
  if (meQ.isError) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}
